import { Redirect } from "react-router-dom";

const GenericNotFound = () => <Redirect to="/" />;

export default GenericNotFound;
